import Animation from './animation'
import * as d3 from 'd3-selection'
import Transformer from '../../pie/transformers/pie-bar-transformer'

/*
 * This animation is used to take series that were previously in a pie or donut
 * chart and turn them into a bar
 */
class FromPieAnimation extends Animation {

  match (serie) {
    if (!this.previous.allSerieTypes[serie.id]) {
      return false
    }

    return this.previous.allSerieTypes[serie.id].type === 'pie' ||
           this.previous.allSerieTypes[serie.id].type === 'donut'
  }

  animate (serie, entering, selection, merged, exiting) {
    this._insertHidden(entering, serie)

    let pies = this.previous.allSerieTypes[serie.id].serie
      , self = this

    pies.transition()
        .duration(this.timing.duration)
        .selectAll('use')
        .style('stroke-width', '4px') // Transition the stroke so it matches the end bar
        .select(function (d) {
          d3.select(`#${d.maskUid.id}`)
            .transition()// Can't inherit transitions since they don't have the same parent
            .duration(self.timing.duration)
            .style('stroke-width', '0px') // Remove mask stroke so it closely matches the bar borders
          return this
        })
        .tween('transform', function (d) {
          let transformer = new Transformer({
            d,
            styles: d.styles,
            width: self.serieScale.bandwidth(),
            x: self.scalers.x.groupScale(d.rangeId) + self.serieScale(serie._columnIdx),
            height: Math.abs(self.yScale(d.slice.data._range[0]) - self.yScale(d.slice.data._range[1])),
            y: self.yScale(Math.max(0, d.slice.data._range[1])),
            path: d3.select(`#${d.pathUid.id}`),
            use: d3.select(this)
          })

          return t => {
            transformer.transform(1 - t) // reverse the timing
          }
        })
        .on('end', d => {
          // Remove the mask and path
          d3.selectAll(`#${d.maskUid.id}, #${d.pathUid.id}`)
            .remove()
          pies.selectAll('use').remove()
        })
        .end().then(() => {
          // Show actual rects
          entering.style('opacity', 1)
        })
  }

}

export default FromPieAnimation
